import usePaginationWrapper from "../general/usePaginationWrapper";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllSectionStart } from "../../redux/section/reducer";
import {
  selectAllSection,
  selectAllSectionLoading,
} from "../../redux/section/selectors";

const useSectionsGet = (paperId) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectAllSectionLoading);
  const sections = useSelector(selectAllSection);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);
  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const fetchSections = useCallback(() => {
    dispatch(
      getAllSectionStart({
        paperId,
        keyword: debouncedSearchText,
        size: limit,
        page: (page - 1) ,
      })
    );
  }, [dispatch, paperId, debouncedSearchText, page, limit]);

  useEffect(() => {
    if (paperId) {
      fetchSections();
    }
  }, [fetchSections, paperId, fetch]);

  useEffect(() => {
    if (sections) {
      setPageable({
        total_elements: sections?.count,
        total_pages: sections?.pages,
        number_of_elements: sections?.items?.length,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections, setPageable]);

  return {
    loadingSection: isLoading,
    sections,
    setOffset,
    setLimit,
    limit,
    offset,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    setSearchText,
    refetch,
  };
};

export default useSectionsGet;
